export default __webpack_public_path__ + "static/media/790245962315464734.c5c3928b.png";